
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.241 10.75a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm4.759 0a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm4.759 0a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    